/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Billing_Board_Cond_State_InvoicedInputs */



/**
* | output |
* | --- |
* | "invoiced but unpaid" |
*
* @param {Partner_Billing_Board_Cond_State_InvoicedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_billing_board_cond_state_invoiced = /** @type {((inputs?: Partner_Billing_Board_Cond_State_InvoicedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Billing_Board_Cond_State_InvoicedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("fakturiert, aber unbezahlt")
	return /** @type {LocalizedString} */ ("invoiced but unpaid")
});